export const visit = (vm, at) => {
at({ "fr": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Effectuez une mise \xE0 niveau" ), " pour r\xE9aliser cette action." ); } } } });
};